var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoFooterYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-footer-youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube",
    d: "M15.993-4.293a2.046,2.046,0,0,0-1.439-1.439,47.8,47.8,0,0,0-6.389-.35,49.659,49.659,0,0,0-6.389.336A2.087,2.087,0,0,0,.336-4.293,21.556,21.556,0,0,0,0-.365,21.477,21.477,0,0,0,.336,3.562,2.046,2.046,0,0,0,1.776,5a47.884,47.884,0,0,0,6.389.35,49.66,49.66,0,0,0,6.389-.336,2.046,2.046,0,0,0,1.439-1.439A21.563,21.563,0,0,0,16.33-.352,20.462,20.462,0,0,0,15.993-4.293ZM6.537,2.083v-4.9l4.25,2.448Zm0,0",
    transform: "translate(7 15.082)",
    fill: "#003652"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFooterYoutube);
export default __webpack_public_path__ + "static/media/ico-footer-youtube.920598be724d85c6377df53583238b34.svg";
export { ForwardRef as ReactComponent };